<template>
  <div
    class="main-header fixed-top"
    v-if="false"
  >
    <b-modal
      id="change-sector"
      ref="changeSector"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
      size="lg"
      :title="resource['sectorSelector.Title']"
      title-tag="h2"
      :centered="true"
      body-class="overflow-unset"
    >
      <validation-observer
        ref="observer"
        v-slot="{passes}"
      >
        <b-form @submit.prevent="passes(saveSector)">
          <h2>
            <strong>{{ resource['sectorSelector.HelperText'] }} </strong>
          </h2>
          <validate-form
            :id="sectorConfig.name"
            v-model="sectorConfig.value"
            which-component="multiselect"
            rules="required"
            type="text"
            autofocus
            class-group="mb-3"
            :name="resource['sectorSelector.Sector']"
            label="displayName"
            :label-form="resource['sectorSelector.Sector'] + ': *'"
            :multiple="sectorConfig.multiple"
            :track-by="sectorConfig.trackBy"
            :placeholder="resource['sectorSelector.Placeholder']"
            :options="sectorConfig.options"
            :loading="sectorConfig.loading"
            :internal-search="sectorConfig.internalSearch"
            :options-limit="sectorConfig.displayedOptionsLimit"
            :limit="sectorConfig.visibleResultLimit"
            :close-on-select="sectorConfig.closeOnSelect"
            :max="sectorConfig.max"
          >
            <span slot="noResult">{{ resource['label.NoResult'] }}</span>
            <span slot="maxElements">{{ resource['label.MaxItem'].data(sectorConfig.max) }}</span>
          </validate-form>
        </b-form>
      </validation-observer>

      <div slot="modal-footer">
        <button
          class="btn md bg-purple text-white"
          type="submit"
          @click="saveSector()"
        >
          {{ resource['label.Save'] }}
        </button>
      </div>
    </b-modal>
    <b-navbar
      id="main_navbar"
      class="navbar-expand"
      :class="!showHeaderButtons ? 'justify-content-between' : ''"
      fixed="top"
      toggleable
      type="inverse"
      variant="white"
    >
      <b-nav-toggle target="nav_collapse" />
      <router-link
        :to="{
          name: 'HrVenueView'
        }"
        class="navbar-brand company-logo m-0 p-0"
        aria-disabled="false"
      >
        <span>
          <img :src="require('@/assets/interview-logo.png')" width="200" />
          <img
            class="d-block d-md-none"
            :src="require('@/assets/logos/kariyer_net_logo_mini_white.png')"
            alt="Kariyer.net logo white mini"
            height="24"
          >
        </span>
      </router-link>

      <i
        v-if="(currentUser.isHolding || currentUser.isHoldingCompany)
          && !siriusCompanyContract.link && showHeaderButtons"
        class="header-arrow"
      />

      <b-collapse
        v-if="(currentUser.isHolding || currentUser.isHoldingCompany)
          && !siriusCompanyContract.link && showHeaderButtons"
        id="nav_collapse"
        is-nav
      >
        <b-navbar-nav
          id="nav_user_profile"
          class="bg-white"
        >
          <b-nav-item-dropdown
            no-caret
            class="mr-sm-4 mr-3"
            left
          >
            <template slot="text">
              <b-button style="max-width:240px;">
                <i class="material-icons">domain</i>
                <span
                  v-if="getCompanyGroup"
                  class="ml-2 mr-2 ellipsis"
                >{{ getCompanyGroup.name }}</span>
                <i class="material-icons">keyboard_arrow_down</i>
              </b-button>
            </template>
            <b-dropdown-header class="text-color-black bold">
              <h4>
                {{ resource['navbar.CompanyGroup.HeaderText'].data(companyGroup.options.length) }}
              </h4>
            </b-dropdown-header>
            <div role="group">
              <div class="search-bar d-flex align-items-center box-shadow">
                <i class="icon-search icon-1x" />
                <input
                  v-model="companyGroup.searchText"
                  class="form-control shadow-none pr-2 pl-2 ellipsis"
                  :placeholder="resource['companyGroup.SearchText']"
                  type="text"
                >
              </div>

              <b-dropdown-item
                v-for="(item, index) in filterList"
                :key="index"
                class="d-flex justify-content-between align-items-center"
                @click="changeCompanyGroup(item)"
              >
                <span class="ellipsis pr-2">{{ item.name }}</span>
                <i class="material-icons sm">settings</i>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="filterList.length == 0"
                class="d-flex justify-content-between align-items-center"
              >
                <span class="ellipsis pr-2">{{ resource['companyGroup.Search.NotFound'] }}</span>
              </b-dropdown-item>
            </div>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>

      <b-collapse
        v-if="!siriusCompanyContract.link && showHeaderButtons"
        id="nav_text_collapse"
        is-nav
      >
        <div id="demo-info-area">
          <b-nav-text class="demo-info-text">
            <i class="icon icon-info demo-info-icon" />
            {{ resource['demoCompany.Reason'] }}
          </b-nav-text>
        </div>
      </b-collapse>

      <b-collapse
        v-if="!siriusCompanyContract.link && showHeaderButtons"
        id="nav_collapse"
        is-nav
      >
        <b-navbar-nav
          id="nav_user_profile"
          class="ml-auto bg-white"
        >
          <b-nav-item-dropdown
            v-if="currentUser.closingDayCount !== 0 && currentUser.companyType !== 0"
            v-authenticate="{
              status:'disabled',
              methods:['question.create','job.kvkk','message.write']
            }"
            no-caret
            class="settings-dropdown mr-sm-4 mr-3"
            right
          >
            <!-- <template slot="text">
              <b-button
                id="settingsButton"
                name="settings"
              >
                <i class="icon icon-settings" />
              </b-button>
            </template> -->
            <div role="group">
              <b-dropdown-header>
                <b>{{ resource['view.GeneralSettings'] }}</b>
              </b-dropdown-header>
              <b-dropdown-item
                v-authenticate="{status:'hide',method:'question.create'}"
                name="job-questions"
                :to="{name:'JobQuestionsView'}"
                class="no-border"
              >
                {{ resource['view.JobQuestions'] }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="!isCompanyBasic"
                name="quick-messages"
                :to="{name:'SettingsMessagesView'}"
                class="no-border"
              >
                {{ resource['view.QuickMessages'] }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="currentUser.companyType !== 0"
                v-authenticate="{status:'hide',method:'job.kvkk'}"
                name="kvkk"
                :to="{name: 'KvkkView'}"
                class="no-border"
              >
                {{ resource['view.Kvkk.Module'] }}
              </b-dropdown-item>
            </div>
          </b-nav-item-dropdown>
          <router-link v-if="showPricingBtn" class="btn pricing" to="/pricing">
            {{ resource["navbar.pricingButton"] }}
          </router-link>
          <div class="language d-flex justify-content-center align-items-center cursor-pointer">
            <span @click="changeLanguage()">{{ language }}</span>
          </div>
          <b-nav-item-dropdown
            right
            class="username-dropdown"
          >
            <template slot="text">
              <span class="rounded-circle">{{ getShortName(currentUser.fullname) }}</span>
            </template>
            <div role="group">
              <b-dropdown-header>
                <b>{{ currentUser.fullname.toUpperCase() }}</b>
              </b-dropdown-header>
              <b-dropdown-item
                :to="{name:'UserListView'}"
                class="no-border myAccount"
              >
                {{ resource['myAccount.User'] }}
              </b-dropdown-item>
              <b-dropdown-item
              :to="{name:'MyAccountView'}"
              class="no-border myAccount"
            >
              {{ resource['myAccount.Profile'] }}
            </b-dropdown-item>
            </div>
            <a
              :class="['logout logoutButton dropdown-item no-border',
                       'text-color-dark-pink d-flex align-items-center justify-content-between']"
              href="javascript:;"
              tabindex="-1"
              role="menuitem"
              @click="logout"
              id="logoutButton"
            >
              <span>{{ resource['label.Logout'] }}</span>
              <i class="icon icon-logout" />
            </a>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
      <div v-if="isOtpStep"
           class="d-flex align-items-center cursor-pointer"
           @click="logout"
      >
        <span class="logout-text">{{ resource['label.Logout'] }}</span>
        <img
          class="ml-2"
          :src="require('@/assets/imgIcons/logout-icon.svg')"
          width="16"
          height="16"
        >
      </div>
    </b-navbar>
    <welcome-demo-popup />
    <whats-news ref="whatsNews" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import AccountService from '@/services/account';
import { serviceWrapper, serviceConfigs } from '@/services/configs';
import {
  handleCookies,
  showNotification,
  handleLoader,
} from '@/static/helpers';
import ResourceManager from '@/services/resource.service';

export default {
  name: 'MainNavbar',

  components: {
    WelcomeDemoPopup: () => import('../common/infos/welcomeDemoPopup.vue'),
    WhatsNews: () => import('../common/infos/WhatsNews.vue'),
  },

  data() {
    return {
      isFullscreenEnabled: true,
      hasFullscreenElement: null,
      userFullName: '',
      whatsNewsClickStatus: false,
      sectorConfig: {
        name: 'sector',
        label: 'displayName',
        trackBy: 'id',
        labelText: 'Sektör',
        options: [],
        loading: false,
        displayedOptionsLimit: 300,
        visibleResultLimit: 10,
        minCharLimit: 3,
        max: 5,
        internalSearch: true,
        multiple: true,
        closeOnSelect: false,
        value: [],
      },
      language: ResourceManager.CurrentLang === 'tr-TR' ? 'EN' : 'TR',
      companyGroup: {
        searchText: '',
        options: [],
      },
      showPricingBtn: false,
    };
  },

  computed: {
    ...mapGetters([
      'getTutorialStatus',
      'getCompanyGroup',
    ]),

    invalid() {
      return this.sectorConfig.value.length === 0;
    },

    getUserFullName() {
      if (this.currentUser) return this.currentUser.fullname;
      return null;
    },

    companyName() {
      return this.currentUser.name.replace(/&nbsp;/g, ' ');
    },

    isUserAdminOrCRM() {
      const { companyUserRoleId, isCrmUser } = this.currentUser;
      return companyUserRoleId === 1 || isCrmUser;
    },

    isRestrictedUser() {
      return (
        this.currentUser.companyUserRoleId === 4
        || this.currentUser.companyUserRoleId === 7
      );
    },

    filterList() {
      return this.companyGroup.options.filter((item) => item.name
        .toLocaleLowerCase(this.currentLang)
        .includes(
          this.companyGroup.searchText.toLocaleLowerCase(this.currentLang),
        ));
    },

    showHeaderButtons () {
      return this.$route.name !== 'MailVerification' && this.$route.name !== 'GsmVerification';
    },

    isOtpStep () {
      return this.$route.name === 'MailVerification' || this.$route.name === 'GsmVerification';
    },
  },

  mounted() {
    this.userFullName = handleCookies.getCookie('userFullName');
    if (!localStorage.getItem('whatsNewsClickStatus')) this.whatsNewsClickStatus = true;

    this.handleFullscreenChange();

    // this.checkWhatsNews();

    this.isFullscreenEnabled = document.fullscreenEnabled
      || document.mozFullScreenEnabled
      || document.webkitFullscreenEnabled;
  },

  methods: {
    ...mapActions([
      'changeUserFilterModel',
      'changeWorkGroupFilterModel',
      'changeCreatedCompanyUserId',
      'changeWorkGroupId',
      'callSetResource',
      'callSetCompanyGroup',
    ]),

    ...mapMutations(['setCompanyClosingDate', 'setCurrentUser']),

    logout () {
      serviceWrapper(
        serviceConfigs.account,
        serviceConfigs.account.logOut,
        {},
      )
        .then((response) => {
          if (response.data.body.isSuccess === true) {
            AccountService.reset2fa();
            // delete token from cookie
            AccountService.deleteToken();
            // redirect to login page
            window.location.reload();
          }
        });
    },

    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },

    showWhatsNews() {
      localStorage.setItem('whatsNewsClickStatus', true);
      this.whatsNewsClickStatus = false;
      this.$refs.whatsNews.open();
    },

    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    },

    checkFullScreenElement() {
      return (
        document.fullscreenElement
        || document.mozFullScreenElement
        || document.webkitFullscreenElement
      );
    },

    handleFullscreenChange() {
      // add listener for fullscreenchange
      ['', 'webkit', 'moz', 'ms'].forEach((prefix) => document.addEventListener(
        `${prefix}fullscreenchange`,
        () => {
          // detect if document has an fullscreen element
          this.hasFullscreenElement = this.checkFullScreenElement();
        },
        false,
      ));
    },

    requestFullScreen() {
      // get document element
      const docD = document.documentElement;

      // check if browser support fullscreen api
      if (this.isFullscreenEnabled) {
        // toggle fullscreen
        if (!this.hasFullscreenElement) {
          this.launchIntoFullscreen(docD);
        } else {
          this.exitFullscreen();
        }
      }
    },

    saveSector() {
      if (!this.invalid) {
        serviceWrapper(
          serviceConfigs.sector,
          serviceConfigs.sector.setCompanySector,
          { CompanySector: this.sectorConfig.value.map((item) => item.id) },
        )
          .then(() => {
            this.$refs.changeSector.hide();

            showNotification(
              this.resource['label.Success'],
              this.resource['notification.Success'],
              'success',
            );
          })
          .catch(() => {
            showNotification(
              this.resource['label.Error'],
              this.resource['notification.Error'],
              'error',
            );
          });
      }
    },

    // checkWhatsNews() {
    //   if (
    //     !localStorage.getItem('whatsNewsStatus18October')
    //     && localStorage.getItem('introJsLogs')
    //   ) {
    //     this.$refs.whatsNews.open();
    //   } else if (localStorage.getItem('introJsLogs'))
    //   localStorage.setItem('whatsNewsStatus18October', true);
    // },

    getShortName(value) {
      let shortName = '';

      if (value) {
        // create name array
        // eslint-disable-next-line no-param-reassign
        value = value.trim().split(' ');
        // create short first char
        if (value[0]) shortName += value[0].substr(0, 1);
        if (value[value.length - 1]) shortName += value[value.length - 1].substr(0, 1);
        return shortName;
      }
    },

    changeLanguage() {
      ResourceManager.CurrentLang = ResourceManager.CurrentLang === 'tr-TR' ? 'en-US' : 'tr-TR';

      handleLoader.showLoader();
      ResourceManager.Get().then((res) => {
        this.language = ResourceManager.CurrentLang === 'tr-TR' ? 'EN' : 'TR';

        this.callSetResource({
          ...res,
          ...{ CurrentLang: ResourceManager.CurrentLang },
        }).then(() => {
          window.location.reload();
        });
      });
      handleLoader.hideLoader();
    },

    changeCompanyGroup(companyGroup) {
      if (companyGroup.id !== this.getCompanyGroup.id) {
        handleLoader.showLoader();
        AccountService.getTokenByCompanyId({ companyId: companyGroup.id }).then(
          () => {
            this.callSetCompanyGroup(companyGroup);
            this.$router.push({ name: 'ActiveJobListView' });
            window.location.reload();
          },
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@/style/starter.scss";
#nav_user_profile {
  height: 32px;

  .dropdown-header {
    padding: 16px;
  }

  .nav-link {
    padding: 0 !important;
    display: flex;
  }

  button {
    margin: 0;
    padding: 0;
    background-color: rgba(255, 255, 255, 0.12);
    color: #fff;
    padding: 8px;

    i {
      margin: 0;
    }
  }

  .dropdown.show {
    button {
      color: #FF8D06 !important;
      background-color: #fff;
      i {
        color: #FF8D06;
      }
    }
  }

  .dropdown-menu {
    overflow: auto;
    max-height: 75vh;
    margin-top: 17px;
    min-width: 265px;
    box-shadow: 0 0 0 1px rgba(131, 22, 181, 0.1),
      0 2px 6px 0 rgba(0, 0, 0, 0.08);
    background: #fff;

    [role="group"] {
      max-width: 350px;
      .dropdown-header {
        background-color: #f9f9f9;
        color: #353535;
        padding: 8px 16px;
      }
    }

    a {
      color: #353535 !important;
      margin: 0;
      padding: 0 16px 0 16px !important;
      height: 49px;
      line-height: 48px !important;
      overflow: hidden;
      position: relative;
      &.logout {
        // &:first-of-type {
        //   margin-top: 16px !important;
        // }
        color: #b62f49 !important;
        background-color: rgba(182, 47, 73, 0.04);
      }
      &:hover {
        background-color: #f9f9f9;
      }

      &.active {
        background-color: #e9e9e9;
      }

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        right: 0;
        display: block;
        height: 1px;
        background-color: #e6e6e6;
        width: calc(100% - 16px);
      }

      &.no-border {
        &:after {
          display: none;
        }
      }
    }

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-track {
      background-color: #e6e6e6;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #b1afaf;
    }
  }
}
.whats-news-dot {
  border-radius: 50%;
  top: -5px;
  padding: 2px;
  right: -5px;
}
.username-dropdown {
  .rounded-circle {
    background: #F5F5F5;
    border: 0.5px solid #353535;
    width: 32px;
    height: 32px;
    font-weight: bold;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow: hidden;
    color: #1D1D1D !important;
  }

  .dropdown-toggle {
    &:after {
      float: right;
      margin-top: 15px;
      margin-left: 11px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 3.5px 0 3.5px;
      border-color: #353535 transparent transparent transparent;
    }
  }
}

#demo-info-area {
  display: none;
}

.demo-company {
  .company-logo {
    position: relative;
  }
  #demo-info-area {
    position: absolute;
    right: 0;
    width: 100%;
    left: 0;
    display: block;
    top: 16px;
    text-align: center;

    .demo-info-text {
      color: #ffffff !important;
      border-radius: 16px;
      background-color: rgba(255, 255, 255, 0.16);
      padding: 8px;
      padding-right: 15px;
      padding-left: 15px;
    }
    .demo-info-icon {
      vertical-align: middle;
      padding-right: 10px;
    }
  }
}

.lang-changer {
  height: 32px;
  width: 32px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid #eeeaf2;
  border-radius: 4px;
  text-align: center;
  margin-right: 16px;
  line-height: 32px;
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0);
}

.box-shadow {
  box-shadow: inset 0px 1px 0px 0px #e6e6e6, inset 0px -1px 0px 0px #e6e6e6;
}

.header-arrow {
  position: relative;
  height: 31px;
  width: 31px;
  margin-right: 8px;
  opacity: 0.5;
  &:before {
    position: absolute;
    width: 31px;
    height: 1px;
    background: #e6e6e6;
    transform: rotate(70deg);
    content: "";
    @include media-breakpoint-down(xs) {
      width: 31px;
    }
  }
  &:after {
    position: absolute;
    width: 31px;
    height: 1px;
    top: 29px;
    background: #e6e6e6;
    transform: rotate(-70deg);
    content: "";
    @include media-breakpoint-down(xs) {
      width: 31px;
      top: 29px;
    }
  }
}

.main-header {
  background: #fff;
  height: 57px;
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
  width: calc(100% - #{$sidebarnew-width});
  left: $sidebarnew-width;
}

.logout-text {font-size: 16px; font-weight: 500; color: #ffffff;}

.language {
  padding-right: 0.75rem;

  span {
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.375rem;
    color: #333333;
  }
}

.pricing {
  background: #353535;
  color:#fff;
  border-radius: 50px;
  padding: 6px 16px;
  font-family: 'Ubuntu', sans-serif !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  margin-right: 32px;

  &:hover {
    color: #fff;
  }
}
</style>
